<template>
  <div>
    <category-header class="z-0" :category="category" />
    <category-products :category="category" />
    <category-footer :category="category" />
  </div>
</template>

<script>
import CategoryHeader from './CategoryHeader'
import CategoryProducts from './CategoryProducts'
import CategoryFooter from './CategoryFooter'

export default {
  components: {
    CategoryHeader,
    CategoryProducts,
    CategoryFooter
  },
  props: {
    category: {
      required: true,
      type: Object
    }
  }
}
</script>
